import logoUppiness from "../../../../assets/icons/logoUppiness.svg";
import LobbyHeaderTeamName from "./LobbyHeaderTeamName";
import LobbyHeaderUserProfile from "./LobbyHeaderUserProfile";

const LobbyHeader = () => {

	return (
		<div className="reusable_header_wrapper" style={{width: "100vw" }}>
			<div className="component_header">

				<div className="component_header_segment">
					<img className="uppiness_logo" src={logoUppiness} alt="Uppiness Logo" />
				</div>

				<div className="component_header_segment">
					<LobbyHeaderTeamName />
				</div>

				<div className="component_header_segment">

					<LobbyHeaderUserProfile />
				</div>
			</div>
		</div>
	);
};

export default LobbyHeader;
